'use strict';

const BaseSelectMenuComponent = require('./BaseSelectMenuComponent');

/**
 * Represents a role select menu component
 * @extends {BaseSelectMenuComponent}
 */
class RoleSelectMenuComponent extends BaseSelectMenuComponent {}

module.exports = RoleSelectMenuComponent;
